import React from "react";
import {
  AppBar,
  Toolbar,
  Container,
  IconButton,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import DealerLogin from "../../compenents/Auth/DealerLogin";
import { CustomerLogin } from "../../compenents/Auth/CustomerLogin";
import Logo from "../../Assets/Logo.svg";

export interface LoginFormValues {
  dmsDealerId?: string;
  username?: string;
  password?: string;
  userType?: number;
  idmsToken?: string;
}

export const Login: React.FunctionComponent = () => {
  const [loginType, setLoginType] = React.useState("dealer");

  const handleSetLoginType = (type: any) => {
    if (type === "dealer") {
      setLoginType("dealer");
    } else if (type === "customer") {
      setLoginType("customer");
    }
  };
  return (
    <>
      <AppBar position="static" variant="outlined">
        <Toolbar
          variant="dense"
          disableGutters
          style={{ minHeight: 64 }}
        ></Toolbar>
      </AppBar>
      <Container
        component="div"
        maxWidth="xs"
        style={{ marginTop: "5%", height: "100%" }}
      >
        <Grid
          container
          style={{
            height: "100%",
            textAlign: "center",
          }}
        >
          <Grid item>
            <Typography noWrap component="div" sx={{ flexGrow: 1, mt: 2 }}>
              <img style={{ maxWidth: "290px" }} src={Logo}></img>
            </Typography>
            <Box component="div" mt={2}>
              <Typography component="h1" variant="h5">
                {loginType === "dealer" ? "Dealer" : "Customer"} Log In
              </Typography>
            </Box>
            {loginType === "dealer" ? (
              <DealerLogin
                handleSetLoginType={handleSetLoginType}
              ></DealerLogin>
            ) : (
              <CustomerLogin
                handleSetLoginType={handleSetLoginType}
              ></CustomerLogin>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
